<template lang="pug" >
.node-icon
  component.node-img(:is="tags.tag", v-bind="tags.attrs")
  span.node-text
    slot
</template>
<script>
export default {
  props: {
    node: { type: Object, default: () => ({}) },
    type: { type: String, default: "" }
  },
  computed: {
    tags() {
      const { type, node } = this;
      const a = { tag: "", attrs: {}};
      let path;
      switch (type) {
        // ┌─────────────────用户────────────────┐
        case "User": {
          a.tag = "img";
          path = node.data.nodeType === "user" ? "user" : `dept${Math.min(3, node.level)}`;
          break;
        }
        case "User.dept": {
          a.tag = "img";
          path = node.data.nodeType === "user" ? "user" : "dept3";
          break;
        }
        case "User.project": {
          a.tag = "img";
          path = node.data.nodeType === "user" ? "user" : `user.prj${Math.min(3, node.level)}`;
          break;
        }
        case "User.specRole": {
          a.tag = "img";
          path = node.data.nodeType === "user" ? "user" : "user.prj3";
          break;
        }
        case "User.sysRole": {
          a.tag = "img";
          path = node.data.nodeType === "user" ? "user" : "role.system";
          break;
        }
        // └───────────────用户──────────────────┘
        case "SystemRole": {
          a.tag = "img";
          path = "role.system";
          break;
        }
        case "SpecRole": {
          a.tag = "img";
          path = node.level === 1 ? "spec" : "role.spec";
          break;
        }
        case "PrjRole": {
          a.tag = "img";
          path = "role.prj";
          break;
        }
        case "Dept": {
          a.tag = "img";
          path = `dept${Math.min(3, node.level || 3)}`;
          break;
        }
        case "Label": {
          a.tag = "img";
          path = "tag";
          break;
        }
        case "TagAndUser": {
          a.tag = "img";
          path = node.data?.userId ? "user" : "tag";
          break;
        }
      }
      if (path) a.attrs.src = require(`../assets/${path}.png`);
      return a;
    }
  }
};
</script>
<style lang="scss" scoped>
.node-text {
  font-size: 14px;
  line-height: 20px;
}
.node-img {
  margin-right: 4px;
  line-height: 20px;
  vertical-align: sub;
}
</style>
